<template>
<!-- 数据统计-用户查询 -->
	<div class="index" v-loading="loading">
		<div class="stats">
			<el-row>
				<el-col style="width: 200px; margin-right: 20px;">
					<el-input size="small" v-model="params.id" placeholder="用户UID搜索"></el-input>
				</el-col>
				<el-col style="width: 200px; margin-right: 20px;">

					<el-date-picker v-model="params.start_time" type="datetime" placeholder="开始日期"
						value-format="yyyy-MM-dd HH:mm:ss" style="width: auto;">
					</el-date-picker>
				</el-col>
				<el-col style="width: 200px; margin-right: 20px;">
					<el-date-picker v-model="params.end_time" type="datetime" placeholder="结束日期"
						value-format="yyyy-MM-dd HH:mm:ss" style="width: auto;">
					</el-date-picker>
				</el-col>
				<el-button type="primary" @click="getData">查询</el-button>
				<el-button type="primary" @click="handleExport">导出</el-button>
			</el-row>
			<p class="prompt">默认展示当天数据</p>
			<div>
				<el-table :data="dataList">
					<el-table-column prop="id" label="用户UID"></el-table-column>
					<el-table-column prop="recharge_amount" label="充值金额"></el-table-column>
					<el-table-column prop="get_out_amount" label="取回金额"></el-table-column>
					<el-table-column prop="trade_amount" label="赠送金额"></el-table-column>
				</el-table>
			</div>
			<div style="margin-top: 80px;">
				<el-table :data="detailList" @sort-change="handleSort">
					<el-table-column prop="name" label="箱子"></el-table-column>
					<el-table-column prop="price" label="箱子单价"></el-table-column>
					<el-table-column prop="lottery_num" label="开箱次数"></el-table-column>
					<el-table-column prop="lottery_price" label="抽奖金额"></el-table-column>
					<el-table-column prop="prize_price" label="出奖金额"></el-table-column>
					<el-table-column prop="shipping_rate" label="出货率"></el-table-column>
					<el-table-column prop="profits" label="利润"></el-table-column>
					<el-table-column prop="user_lottery_price" label="用户抽奖金额" sortable="custom"></el-table-column>
					<el-table-column prop="user_prize_price" label="用户出奖金额"></el-table-column>
					<el-table-column prop="user_shipping_rate" label="用户出货率"></el-table-column>
					<el-table-column prop="user_profits" label="用户利润"></el-table-column>
				</el-table>
			</div>
			<el-pagination background :total="dataMeta ? dataMeta.total : 0"
				:current-page="dataMeta ? dataMeta.current_page : 1" :page-size="dataMeta ? dataMeta.per_page : 10"
				@current-change="handlePageChange" v-if="dataMeta && dataMeta.total > dataMeta.per_page"></el-pagination>
		</div>
	</div>
</template>

<script>
	import http, {
		getData,
		postData,
		patchData,
		server,
		api,
		postApiData,
		patchApiData,
		getApiData
	} from '../../http'
	import saveFile from '@/utils/saveFile'

	export default {
		data() {
			return {
				visible: false,
				loading: false,
				loadingDetail: false,
				dataList: undefined,
				detailList: undefined,
				dataMeta: {},
				params: {
					id: undefined,
					start_time: undefined,
					end_time: undefined,
					page: undefined,
					order_field: 'id',
					order_sort: 'desc'
				}
			}
		},
		methods: {
			getData() {
				this.loading = true
				getApiData('user_statistics', {
						...this.params
					})
					.then(res => {
						this.dataList = res.data
						this.dataMeta = res.meta
						this.detailList = res.box_data
					})
					.finally(() => {
						this.loading = false
					})
			},
			handleSort(column) {
				this.params.order_field = column.prop
				this.params.order_sort = column.order === 'ascending' ? 'asc' : 'desc'
				this.params.page = 1
				this.getData()
			},
			handlePageChange(page) {
				this.params.page = page
				this.getData()
			},
			handleExport() {
				http
					.post(
						api + 'user_statistics_export', {
							id: this.params.id,
							start_time: this.params.start_time,
							end_time: this.params.end_time
						}, {
							responseType: 'arraybuffer'
						}
					)
					.then(res => {
						saveFile(res, {
							type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
							name: '用户开箱查询.xlsx'
						})
					})
			}
		},
		created() {
			this.getData()
		}
	}

</script>

<style>
</style>
